module.exports = __webpack_public_path__ + "img/icon-filter-nor.534be54e.svg";